import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const AddNewRole = () => {
  const { baseUrl, openToast,fetchRoles } = useGlobalContext();
  // State for role name and permissions
  const [roleName, setRoleName] = useState("");
  const [isAddingRole,setIsAddingRole] = useState(false);
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState({
    clients_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    projects_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    report_permissions: { view_global: false, view_time_sheets: false },
    staff_role_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    settings_permissions: { view_global: false, view_time_sheets: false },
    staff_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    task_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    sub_task_permissions: {
      view_global: false,
      create: false,
      edit: false,
      delete: false,
    },
    chat_module_permissions: { grant_access: false },
    ai_permissions: { grant_access: false },
  });
  const [isLoading, setIsLoading] = useState(false);

  // Handler for role name input change
  const handleRoleNameChange = (e) => {
    setRoleName(e.target.value);
  };

  // Handler for permissions change
  const handlePermissionChange = (section, permission) => {
    setPermissions((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [permission]: !prev[section][permission],
      },
    }));
  };
  useEffect(() => {
    console.log(permissions);
  }, [permissions]);

  // Submit role function
  async function submitRole() {
    setIsAddingRole(true);
    try {
      setIsLoading(true);
      const formattedRole = {
        roleName, // the role name string
        permissions: { ...permissions }, // correctly formatted permissions object
      };

      const response = await fetch(baseUrl + "role", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(formattedRole), // send the formatted data
      });

      const result = await response.json();
      if (response.status === 200) {
        console.log(result);
        setIsAddingRole(false);
        openToast(result.message || "Role successfully added");
        navigate("/role-detail");
        fetchRoles()
      } else {
        openToast(result.message || "An Error Occured");
      }
    } catch (error) {
      console.log("error:", error);
    } finally {
      setIsAddingRole(false);
      setRoleName("");
    }
  }

  return (
    <div className="mb-3 pr-2 pb-4 pl-[10px] w-[100%] addnewrole">
      <h2 className="font-medium text-[#27004a] text-[18px]">Add New Role</h2>

      <div className="w-[100%]">
        <div className="bg-[#fff] set-shadow mt-2 p-3 rounded-md w-[100%] md:w-[50%] lg:w-[50%] xl:w-[50%]">
          <label>Role Name</label>
          <br />
          <input
            type="text"
            className="border-1 mt-2 pr-7 pl-3 border rounded-md w-[100%] h-[43px] text-[#aeabab] text-[15px] focus:outline-none"
            value={roleName}
            onChange={handleRoleNameChange}
          />

          <table className="border-1 mt-5 border w-[100%]">
            <thead className="border-1 border">
              <tr>
                <th className="p-2 border-r-[1px] font-medium text-left">
                  Features
                </th>
                <th className="p-2 font-medium text-left">Capabilities</th>
              </tr>
            </thead>
            <tbody className="table-body-set">
              {/* Clients Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Clients
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "clients_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.create}
                    onChange={() =>
                      handlePermissionChange("clients_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("clients_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.clients_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("clients_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Projects Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Projects
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "projects_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.create}
                    onChange={() =>
                      handlePermissionChange("projects_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("projects_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.projects_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("projects_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Report Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Report
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.report_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "report_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.report_permissions.view_time_sheets}
                    onChange={() =>
                      handlePermissionChange(
                        "report_permissions",
                        "view_time_sheets"
                      )
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    View Timesheets Report
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Setting Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Setting
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.settings_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "settings_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.settings_permissions.view_time_sheets}
                    onChange={() =>
                      handlePermissionChange(
                        "settings_permissions",
                        "view_time_sheets"
                      )
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    View Timesheets Report
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Staff Role Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Staff Role
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "staff_role_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.create}
                    onChange={() =>
                      handlePermissionChange("staff_role_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("staff_role_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_role_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("staff_role_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Staff  Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Staff{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "view_global")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.create}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.staff_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("staff_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Task  Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "view_global")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.create}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.task_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("task_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Sub Task  Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px]">
                  Sub Task{" "}
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.view_global}
                    onChange={() =>
                      handlePermissionChange(
                        "sub_task_permissions",
                        "view_global"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    View Global
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.create}
                    onChange={() =>
                      handlePermissionChange("sub_task_permissions", "create")
                    }
                  />
                  <label className="ml-2 text-[#64748b] text-[14px] cursor-pointer">
                    Create
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.edit}
                    onChange={() =>
                      handlePermissionChange("sub_task_permissions", "edit")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Edit
                  </label>
                  <br />

                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.sub_task_permissions.delete}
                    onChange={() =>
                      handlePermissionChange("sub_task_permissions", "delete")
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Delete
                  </label>
                  <br />
                  <br />
                </td>
              </tr>

              {/* Chat Module Section */}
              <tr className="border-1 border">
                <td className="p-3 border-r-[1px] font-normal text-[#64748b] text-[16px] whitespace-nowrap">
                  Chat Module
                </td>
                <td className="p-3">
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={permissions.chat_module_permissions.grant_access}
                    onChange={() =>
                      handlePermissionChange(
                        "chat_module_permissions",
                        "grant_access"
                      )
                    }
                  />
                  <label className="ml-3 text-[#64748b] text-[14px] cursor-pointer">
                    Grant Access
                  </label>
                  <br />
                </td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-end gap-[10px] mt-3 text-end">
            <Link
              to="/role-detail"
              className="flex items-center hover:bg-[#7526d1] py-2 pt-2 pr-5 pl-5 rounded-md text-white first-btn"
            >
              Cancel
            </Link>
            <button
              className={` ${
                isAddingRole == true ? "second-btn-disabled" : "second-btn"
              }`}
              onClick={submitRole}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewRole;
